export const BASE_URL = "https://backend-c551.onrender.com";
